import { i18n } from 'i18next';
import { SxProps } from '@mui/material';

export const switchLabel = (i18n: i18n, enabled: boolean): SxProps => {
  return {
    ...(enabled ? { fontWeight: 500 } : { color: '#676767' }),
    ...(i18n.language === 'fr' ? { letterSpacing: '-1px' } : {}),
  };
};
